import * as ɵngcc0 from '@angular/core';
export { AbpBaseConstant, AbpCheckFieldModel, AbpCheckListFieldModel, AbpDatepickerFieldModel, AbpDropDownFieldModel, AbpLabelFieldModel, AbpRadioButtonFieldModel, AbpSwitchFieldModel, AbpTextFieldModel, ControlBase, ConversionHelper, DateConstant, DateHelper, DateModel, DatePartModel, FieldModel, FieldType, InputFieldModel, SelectListControlBase, SelectListFieldModel, SelectListItem, StringHelper, ValueAccessorBase } from '@colibrium/abp-form-control-base';
import { AbpButtonModule } from '@colibrium/abp-button';
export { AbpButtonControlComponent, AbpButtonFieldModel, AbpButtonModule, AbpIconButtonControlComponent, AbpIconButtonFieldModel, AbpLinkButtonControlComponent, AbpResetButtonControlComponent, AbpSubmitButtonControlComponent, AbpTransButtonControlComponent, AbpTransIconButtonControlComponent, ɵa } from '@colibrium/abp-button';
import { AbpCheckboxModule } from '@colibrium/abp-checkbox';
export { AbpCheckBoxControlComponent, AbpCheckBoxListControlComponent, AbpCheckboxConstant, AbpCheckboxModule } from '@colibrium/abp-checkbox';
import { AbpDatepickerConstant, AbpDatepickerModule } from '@colibrium/abp-datepicker';
export { AbpDatepickerComponent, AbpDatepickerConstant, AbpDatepickerModule } from '@colibrium/abp-datepicker';
import { AbpDropdownModule } from '@colibrium/abp-dropdown';
export { AbpDropdownModule, AbpSingleSelectDropdownComponent } from '@colibrium/abp-dropdown';
import { AbpLabelConstant, AbpLabelModule } from '@colibrium/abp-label';
export { AbpFieldDisplayLabelComponent, AbpLabelComponent, AbpLabelConstant, AbpLabelModule } from '@colibrium/abp-label';
import { AbpRadionButtonModule } from '@colibrium/abp-radiobutton';
export { AbpRadioButtonListComponent, AbpRadioConstant, AbpRadioListInlineComponent, AbpRadionButtonModule, AbpSwitchComponent } from '@colibrium/abp-radiobutton';
import { AbpTextboxConstant, AbpTextboxModule } from '@colibrium/abp-textbox';
export { AbpPasswordControlComponent, AbpTextBoxControlComponent, AbpTextboxConstant, AbpTextboxModule } from '@colibrium/abp-textbox';
import { AbpValidationDisplayConstant, AbpValidationDisplayModule } from '@colibrium/abp-validation-display';
export { AbpValidationDisplayComponent, AbpValidationDisplayConstant, AbpValidationDisplayModule } from '@colibrium/abp-validation-display';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/abp-form-control-config.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
/**
 * @record
 */
function AbpFormControlConfigModel() { }
if (false) {
    /** @type {?} */
    AbpFormControlConfigModel.prototype.dateConfig;
    /** @type {?|undefined} */
    AbpFormControlConfigModel.prototype.textConfig;
    /** @type {?|undefined} */
    AbpFormControlConfigModel.prototype.validationConfig;
    /** @type {?|undefined} */
    AbpFormControlConfigModel.prototype.labelConfig;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/abp-form-control.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion pipes/filters
class AbpFormControlModule {
    constructor() {
    }
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return (/** @type {?} */ ({
            ngModule: AbpFormControlModule,
            providers: [
                { provide: AbpDatepickerConstant.dateConfigInjectKey, useValue: config.dateConfig },
                { provide: AbpTextboxConstant.textboxConfigInjectKey, useValue: config.textConfig },
                { provide: AbpValidationDisplayConstant.validationDisplayConfigInjectKey, useValue: config.validationConfig },
                { provide: AbpLabelConstant.labelConfigInjectKey, useValue: config.labelConfig }
            ]
        }));
    }
}
AbpFormControlModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpFormControlModule });
AbpFormControlModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpFormControlModule_Factory(t) { return new (t || AbpFormControlModule)(); }, providers: [], imports: [[
            CommonModule,
            AbpValidationDisplayModule,
            AbpButtonModule,
            AbpCheckboxModule,
            AbpDatepickerModule,
            AbpTextboxModule,
            AbpDropdownModule,
            AbpRadionButtonModule,
            AbpLabelModule
        ], AbpValidationDisplayModule,
        AbpButtonModule,
        AbpCheckboxModule,
        AbpDatepickerModule,
        AbpTextboxModule,
        AbpDropdownModule,
        AbpRadionButtonModule,
        AbpLabelModule] });
/** @nocollapse */
AbpFormControlModule.ctorParameters = () => [];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpFormControlModule, { imports: function () { return [CommonModule,
        AbpValidationDisplayModule,
        AbpButtonModule,
        AbpCheckboxModule,
        AbpDatepickerModule,
        AbpTextboxModule,
        AbpDropdownModule,
        AbpRadionButtonModule,
        AbpLabelModule]; }, exports: function () { return [AbpValidationDisplayModule,
        AbpButtonModule,
        AbpCheckboxModule,
        AbpDatepickerModule,
        AbpTextboxModule,
        AbpDropdownModule,
        AbpRadionButtonModule,
        AbpLabelModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpFormControlModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    AbpValidationDisplayModule,
                    AbpButtonModule,
                    AbpCheckboxModule,
                    AbpDatepickerModule,
                    AbpTextboxModule,
                    AbpDropdownModule,
                    AbpRadionButtonModule,
                    AbpLabelModule
                ],
                declarations: [],
                entryComponents: [],
                exports: [
                    AbpValidationDisplayModule,
                    AbpButtonModule,
                    AbpCheckboxModule,
                    AbpDatepickerModule,
                    AbpTextboxModule,
                    AbpDropdownModule,
                    AbpRadionButtonModule,
                    AbpLabelModule
                ],
                providers: []
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: colibrium-abp-form-control.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpFormControlModule };

//# sourceMappingURL=colibrium-abp-form-control.js.map